var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.16 24l8.145 8.145c2.107 2.107-1.053 5.267-3.16 3.16L24 27.161l-8.145 8.144c-2.107 2.107-5.267-1.053-3.16-3.16L20.839 24l-8.144-8.145c-2.107-2.107 1.053-5.267 3.16-3.16L24 20.839l8.145-8.144c2.107-2.107 5.267 1.053 3.16 3.16L27.161 24z",
    id: "close_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#close_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#close_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTI3LjE2IDI0bDguMTQ1IDguMTQ1YzIuMTA3IDIuMTA3LTEuMDUzIDUuMjY3LTMuMTYgMy4xNkwyNCAyNy4xNjFsLTguMTQ1IDguMTQ0Yy0yLjEwNyAyLjEwNy01LjI2Ny0xLjA1My0zLjE2LTMuMTZMMjAuODM5IDI0bC04LjE0NC04LjE0NWMtMi4xMDctMi4xMDcgMS4wNTMtNS4yNjcgMy4xNi0zLjE2TDI0IDIwLjgzOWw4LjE0NS04LjE0NGMyLjEwNy0yLjEwNyA1LjI2NyAxLjA1MyAzLjE2IDMuMTZMMjcuMTYxIDI0eiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIG1hc2s9InVybCgjYikiIGZpbGw9ImN1cnJlbnRDb2xvciI+PHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPjwvZz48L2c+PC9zdmc+";
export { SvgClose as ReactComponent };